import { ProductChoiceType } from '@thg-commerce/enterprise-config'
import { SiteProperties } from '../../../graphql/horizon-schema'

import { TransformedChoice } from './choice'

export interface SelectedOptions {
  [optionKey: string]: string
}

export interface TransformedOption {
  key: string
  type: ProductChoiceType
  placeholder: string
  label: string
  choices: TransformedChoice[]
  attribute?: boolean | null
  optionsOrder: number[] | null
  disabled: boolean
}

export interface ProductChoiceTypeMap {
  [optionKey: string]: {
    type: ProductChoiceType
    placeholderPropertyKey: string
    propertyKey: string
  }
}

interface OptionProps {
  optionKey: string
  choices: TransformedChoice[]
  siteProperties: SiteProperties
  optionKeysToApplyAttribute?: string[]
  productChoiceTypeMap?: ProductChoiceTypeMap
  optionsOrder?: number[]
}

export const option = (props: OptionProps): TransformedOption => {
  const productChoiceType = props.productChoiceTypeMap
    ? props.productChoiceTypeMap[props.optionKey]
    : null

  return {
    choices: props.choices,
    optionsOrder: props.optionsOrder ?? null,
    key: props.optionKey,
    label:
      productChoiceType &&
      props.siteProperties?.[productChoiceType.propertyKey]?.value
        ? props.siteProperties[productChoiceType.propertyKey].value
        : props.optionKey,
    placeholder:
      productChoiceType &&
      props.siteProperties?.[productChoiceType?.placeholderPropertyKey]
        ? props.siteProperties[productChoiceType.placeholderPropertyKey].value
        : '',
    type: productChoiceType?.type
      ? productChoiceType.type
      : ProductChoiceType.DROPDOWN,
    attribute: props.optionKeysToApplyAttribute
      ? props.optionKeysToApplyAttribute.includes(props.optionKey)
        ? true
        : null
      : null,
    disabled: false, // @TODO:REBUILD-8627 showOutOfStockAsDisabled ? !variant.inStock : false, showOutOfStockAsDisabled= pageTheme?.theme.productOptions.showOutOfStockAsDisabled,
  }
}
